'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { 
  LayoutDashboard, 
  Wallet, 
  LayoutGrid, 
  TrendingUp, 
  Settings, 
  Users, 
  X,
  CreditCard,
  Flag,
  Menu,
  Lightbulb,
  Repeat,
  LogOut
} from 'lucide-react';
import { clsx } from 'clsx';
import { logout } from '@/app/actions/auth';

const menuItems = [
  { icon: LayoutDashboard, name: 'Dashboard', path: '/' },
  { icon: Wallet, name: 'Transactions', path: '/transactions' },
  { icon: LayoutGrid, name: 'Budget', path: '/budget' },
  { icon: Repeat, name: 'Recurring', path: '/fixed-costs' },
  { icon: Flag, name: 'Savers', path: '/goals' },
  { icon: CreditCard, name: 'Accounts', path: '/accounts' },
  { icon: TrendingUp, name: 'Journey', path: '/journey' },
  { icon: Lightbulb, name: 'Insights', path: '/insights' },
  { icon: Users, name: 'Family', path: '/family' },
  { icon: Settings, name: 'Settings', path: '/settings' },
];

export default function MobileNav() {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  if (pathname === '/auth') return null;

  const handleLogout = async () => {
    await logout();
    window.location.href = '/auth';
  };

  return (
    <>
      {/* Bottom Navigation Bar */}
      <div className="mobile-bottom-bar">
        <Link href="/" className={clsx("nav-item", pathname === "/" && "active")}>
          <LayoutDashboard size={20} />
        </Link>
        
        <Link href="/transactions" className={clsx("nav-item", pathname === "/transactions" && "active")}>
          <Wallet size={20} />
        </Link>
        
        <button 
          className={clsx("nav-item menu-trigger", isOpen && "active")}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
        
        <Link href="/accounts" className={clsx("nav-item", pathname === "/accounts" && "active")}>
          <CreditCard size={20} />
        </Link>
        
        <Link href="/goals" className={clsx("nav-item", pathname === "/goals" && "active")}>
          <Flag size={20} />
        </Link>
      </div>

      {/* Full Screen Overlay */}
      {isOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-menu-content">
            <div className="mobile-menu-header">
               <img src="/logo_v2.png" alt="Logo" style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
               <span style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--accent)' }}>MyMoneyMagic</span>
            </div>
            
            <div className="mobile-menu-grid">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = pathname === item.path;
                return (
                  <Link 
                    key={item.path} 
                    href={item.path}
                    className={clsx('mobile-grid-item', isActive && 'active')}
                    onClick={() => setIsOpen(false)}
                  >
                    <div className="icon-wrapper">
                      <Icon size={24} />
                    </div>
                    <span>{item.name}</span>
                  </Link>
                );
              })}
            </div>

            <div className="mobile-menu-footer">
               <button onClick={handleLogout} className="mobile-logout-btn">
                  <LogOut size={20} />
                  <span>Secure Logout</span>
               </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
}
